import Selectr from 'mobius1-selectr'


// Popup
(function($) {
    'use strict';
    if ($.isFunction($.fn['themePluginPopup'])) {

        $(function() {
            $('[data-plugin-popup]').each(function() {
                var $this = $(this),
                    opts;

                var pluginOptions = theme.fn.getOptions($this.data('plugin-options'));
                if (pluginOptions)
                    opts = pluginOptions;

                $this.themePluginPopup(opts);
            });
        });

    }
}).apply(this, [jQuery]);


// Scrollto
(function($) {
    'use strict';
    if ($.isFunction($.fn['themePluginScrollto'])) {

        $(function() {
            $('[data-plugin-scrollto]').each(function() {
                var $this = $(this),
                    opts;

                var pluginOptions = theme.fn.getOptions($this.data('plugin-options'));
                if (pluginOptions)
                    opts = pluginOptions;

                $this.themePluginScrollto(opts);
            });
        });

    }
}).apply(this, [jQuery]);


// Selectr
(function($) {
    'use strict';
    if (typeof Selectr === "function") {

        $(function() {
            $('[data-plugin-selectr]').each(function() {

                let $this = $(this),

                    defaultOptions = {
                        messages: {
                            noResults: "No results.",
                            maxSelections: "A maximum of {max} items can be selected.",
                            tagDuplicate: "That tag is already in use",
                        }
                    },

                    pluginOptions = theme.fn.getOptions($this.data('plugin-options'));

                let opts = $.extend(true, {}, pluginOptions, defaultOptions);

                new Selectr(this, opts);
            });
        });

    }
}).apply(this, [jQuery]);


// Sticky
(function($) {
    'use strict';
    if ($.isFunction($.fn['themePluginSticky'])) {

        $(function() {
            $('[data-plugin-sticky]:not(.manual)').each(function() {
                var $this = $(this),
                    opts;

                var pluginOptions = theme.fn.getOptions($this.data('plugin-options'));
                if (pluginOptions)
                    opts = pluginOptions;

                $this.themePluginSticky(opts);
            });
        });

    }
}).apply(this, [jQuery]);


// Commom Partials
(function($) {
    'use strict';

    // Sticky Header
    if (typeof theme.StickyHeader !== 'undefined') {
        theme.StickyHeader.initialize();
    }

}).apply(this, [jQuery]);